import { render, staticRenderFns } from "./gym.vue?vue&type=template&id=710d007f&"
import script from "./gym.vue?vue&type=script&lang=js&"
export * from "./gym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports